import Swiper from 'swiper/bundle'; // css file is added locally

let fontSize = parseFloat($('body').css('font-size'));

$(window).on('resize', function () {
    fontSize = parseFloat($('body').css('font-size'));
});

const swiperCards = new Swiper('.cards__slider', {
    slidesPerView: 1,
    spaceBetween: fontSize,
    speed: 300,
    breakpoints: {
        401: {
            slidesPerView: 1.1,
            spaceBetween: fontSize,
        },
        651: {
            slidesPerView: 2,
            spaceBetween: fontSize,
        },
        849: {
            slidesPerView: 2,
            spaceBetween: (fontSize*2),
        },
        1065: {
            slidesPerView: 3,
            spaceBetween: (fontSize*2),
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

const swiperUSPs = new Swiper('.usps__slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: fontSize,
    speed: 500,
    autoplay: {
        delay: 3000,
    },
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

const swiperGallery = new Swiper('.gallery__slider', {
    slidesPerView: 3,
    spaceBetween: fontSize*2/3,
    speed: 300,
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            spaceBetween: fontSize,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});
